import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SideTopBarComponent } from './side-top-bar/side-top-bar.component';
import { PatientCardComponent } from './patient-card/patient-card.component';
import { ButtonComponent } from './button/button.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { ConfirmationPanelComponent } from './confirmation-panel/confirmation-panel.component';
import { PanelWithTextAreaComponent } from './panel-with-text-area/panel-with-text-area.component';
import { FormsModule } from '@angular/forms';
import { FilterPanelComponent } from './filter-panel/filter-panel.component';
import { PanelWithInputBoxesComponent } from './panel-with-input-boxes/panel-with-input-boxes.component';
import { PanelWithDocumentUploadComponent } from './panel-with-document-upload/panel-with-document-upload.component';
import { AddNewPatientPanelComponent } from './add-new-patient-panel/add-new-patient-panel.component';
import { PatientNotesComponent } from './patient-notes/patient-notes.component';
import { PatientRemindersComponent } from './patient-reminders/patient-reminders.component';
import { TableComponent } from './table/table.component';
import { PanelWithCheckboxListComponent } from './panel-with-checkbox-list/panel-with-checkbox-list.component';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { CalendarComponent } from './calendar/calendar.component';
import { FlatpickrModule } from 'angularx-flatpickr';
import { TodayAppointmentCardComponent } from './today-appointment-card/today-appointment-card.component';
import {
  CalendarDateFormatter,
  CalendarNativeDateFormatter,
} from 'angular-calendar';
import { PanelCalendarEventComponent } from './panel-calendar-event/panel-calendar-event.component';
import { PanelModifyCalendarEventComponent } from './panel-modify-calendar-event/panel-modify-calendar-event.component';
import { LoaderComponent } from './loader/loader.component';
import { LifelineSectionComponent } from '../sections/lifeline-section/lifeline-section.component';
import { SignificantEventsSectionComponent } from '../sections/significant-events-section/significant-events-section.component';
import { PanelLifelineEventComponent } from './panel-lifeline-event/panel-lifeline-event.component';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';

// Material Datepicker Imports
// FIXME: remove all material datepicker imports if they turn out not to be necessary
import { MatFormField, MatFormFieldModule } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerModule,
  MatDatepickerToggle,
} from '@angular/material/datepicker';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatCardModule } from '@angular/material/card';
import { MatCardActions } from '@angular/material/card';
// Angular Material Imports
import { MatButtonModule } from '@angular/material/button';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { ReactiveFormsModule } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { ShowOnSubmitErrorStateMatcher } from './material-error-state-matcher/error-state-matcher';
import { DateInputDirective } from './directives/date-input.directive';

// Circle progress used for AI analysis page during file upload
import { NgCircleProgressModule } from 'ng-circle-progress';

// next three lines needed to render dates in italian
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { PanelErrorComponent } from './panel-error/panel-error.component';
import { TableInvoicesComponent } from './table-invoices/table-invoices.component';
import { MatChipsModule } from '@angular/material/chips';
registerLocaleData(localeIt);

import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { ClientCardComponent } from './client-card/client-card.component';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { InfoPanelComponent } from './info-panel/info-panel.component';
import { CalendarsInfoPanelComponent } from './calendars-info-panel/calendars-info-panel.component';
import { MatSortModule } from '@angular/material/sort';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TopBarSearchComponent } from './side-top-bar/top-bar-search/top-bar-search.component';
import { TableReceivedInvoicesComponent } from '../pages/invoices-received/table-received-invoices/table-received-invoices.component';
import { RouterLink } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AiDisclaimerComponent } from './ai-disclaimer/ai-disclaimer.component';

@NgModule({
  declarations: [
    SideTopBarComponent,
    PatientCardComponent,
    ButtonComponent,
    CheckboxComponent,
    ConfirmationPanelComponent,
    PanelWithTextAreaComponent,
    FilterPanelComponent,
    PanelWithInputBoxesComponent,
    PanelWithDocumentUploadComponent,
    AddNewPatientPanelComponent,
    PatientNotesComponent,
    PatientRemindersComponent,
    TableComponent,
    PanelWithCheckboxListComponent,
    CalendarComponent,
    TodayAppointmentCardComponent,
    PanelCalendarEventComponent,
    PanelModifyCalendarEventComponent,
    LoaderComponent,
    LifelineSectionComponent,
    SignificantEventsSectionComponent,
    PanelLifelineEventComponent,
    PanelErrorComponent,
    ClientCardComponent,
    DateInputDirective,
    TableInvoicesComponent,
    TableReceivedInvoicesComponent,
    InfoPanelComponent,
    CalendarsInfoPanelComponent,
  ],
  exports: [
    SideTopBarComponent,
    PatientCardComponent,
    ButtonComponent,
    CheckboxComponent,
    ConfirmationPanelComponent,
    PanelWithTextAreaComponent,
    FilterPanelComponent,
    PanelWithInputBoxesComponent,
    PanelWithDocumentUploadComponent,
    AddNewPatientPanelComponent,
    PatientNotesComponent,
    PatientRemindersComponent,
    TableComponent,
    PanelWithCheckboxListComponent,
    CalendarComponent,
    TodayAppointmentCardComponent,
    PanelCalendarEventComponent,
    PanelModifyCalendarEventComponent,
    LoaderComponent,
    LifelineSectionComponent,
    SignificantEventsSectionComponent,
    PanelLifelineEventComponent,
    PanelErrorComponent,
    TableInvoicesComponent,
    TableReceivedInvoicesComponent,
    MatSlideToggleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    ClientCardComponent,
    InfoPanelComponent,
    CalendarsInfoPanelComponent,
    AiDisclaimerComponent,
  ],
  imports: [
    RouterLink,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlatpickrModule.forRoot(),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    MatIcon,
    MatIconButton,
    MatFormField,
    MatFormFieldModule,
    MatInput,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatDatepicker,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCardModule,
    MatCardActions,
    MatButtonModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    MatMenuModule,
    MatIconModule,
    NgCircleProgressModule.forRoot({
      // set defaults here
      radius: 100,
      outerStrokeWidth: 16,
      innerStrokeWidth: 8,
      outerStrokeColor: '#78C000',
      innerStrokeColor: '#C7E596',
      startFromZero: false,
    }),
    MatInputModule,
    MatTableModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    MatMomentDateModule,
    MatChipsModule,
    MatSortModule,
    MatCheckboxModule,
    TopBarSearchComponent,
    MatTooltipModule,
    AiDisclaimerComponent,
  ],
  providers: [
    { provide: CalendarDateFormatter, useClass: CalendarNativeDateFormatter },
    { provide: LOCALE_ID, useValue: 'it-IT' },
    { provide: ErrorStateMatcher, useClass: ShowOnSubmitErrorStateMatcher },
    { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class SharedModule {}
